<template>
  <div>
    <SignUpModule></SignUpModule>
  </div>
</template>

<script>
import SignUpModule from "@/components/SignUpModule.vue";
export default {
  name: "SignUp", 
  components: {
    SignUpModule
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/my/components/signUp.vue